export default __webpack_public_path__ + "static/media/progress.451d0c58.png";